import { BulkActionProspect } from '../../enums/prospect';
import { Filters, ProspectListPayload } from '../../types';

type UpdateProspectListHandlerProps = {
  action: BulkActionProspect;

  filters: Filters;
  setProspectFilters: (payload: Filters) => void;

  fetchProspectList?: boolean;
  fetchProspectListCount?: boolean;

  sendGetProspectListRequest: (payload: ProspectListPayload) => void;
  sendGetProspectListCountRequest: (payload: ProspectListPayload) => void;

  resetPageNumber?: boolean;
  resetBulkRequests: VoidFunction;
};

export const updateProspectListHandler = ({
  filters,
  setProspectFilters,

  fetchProspectList = false,
  fetchProspectListCount = false,

  sendGetProspectListRequest,
  sendGetProspectListCountRequest,

  resetPageNumber = false,
  resetBulkRequests,
}: UpdateProspectListHandlerProps) => {
  if (fetchProspectList) {
    const {
      pageNum,
      pageSize,
      selectedFields,
      sortBy,
      sortOrder,
      search,
      filterGroupLogic,
    } = filters;
    sendGetProspectListRequest({
      pageNum: resetPageNumber ? 1 : pageNum,
      pageSize,
      sortBy:
        // eslint-disable-next-line no-restricted-globals
        sortBy != null && !isNaN(Number(sortBy)) ? Number(sortBy) : sortBy,
      sortOrder,
      search,
      filterGroupLogic,
      selectedField: selectedFields.map((f) => f.id.toString()),
    });

    if (resetPageNumber) {
      setProspectFilters({ ...filters, pageNum: 1 });
    }
  }

  if (fetchProspectListCount) {
    const { selectedFields, search, filterGroupLogic } = filters;
    sendGetProspectListCountRequest({
      search,
      filterGroupLogic,
      selectedField: selectedFields.map((f) => f.id.toString()),
    });
  }

  resetBulkRequests();
};
